import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const r = t((e, o) => /* @__PURE__ */ l.jsx(
  a,
  {
    ref: o,
    ...e,
    image: (s) => /* @__PURE__ */ l.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...s,
        children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11.945 4.606c-.902 1.01-1.445 2.533-1.445 4.532q0 .748.04 1.427l-.04-.065c-2.5-1.5-2 4 .5 4h.215c.334 1.048.762 1.874 1.232 2.512l.053.071q.177.233.361.433C13.851 18.594 14.996 19 16 19c1.128 0 2.435-.513 3.5-1.917l.053-.07c.476-.646.907-1.483 1.242-2.547L21 14.5c2.5 0 3-5.5.5-4l-.039.04q.039-.669.039-1.402c0-1.999-.543-3.522-1.445-4.532C19.166 3.61 17.831 3 16 3s-3.166.61-4.055 1.606m.555 15.5v-.251C13.605 20.64 14.826 21 16 21s2.395-.36 3.5-1.145v.25a2 2 0 0 0 1.309 1.877l6.206 2.287a4 4 0 0 1 2.498 2.783l.426 1.706A1 1 0 0 1 28.97 30H3.031a1 1 0 0 1-.97-1.242l.426-1.706a4 4 0 0 1 2.498-2.783l6.206-2.287a2 2 0 0 0 1.309-1.877",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "ChestIcon";
export {
  r as ChestIcon,
  r as default
};
//# sourceMappingURL=index.js.map
